var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTagDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81472 2.37061H2.29216C1.94946 2.37061 1.62079 2.50674 1.37846 2.74907C1.13614 2.9914 1 3.32006 1 3.66277V12.7079C1 13.0506 1.13614 13.3793 1.37846 13.6216C1.62079 13.8639 1.94946 14.0001 2.29216 14.0001H11.3373C11.68 14.0001 12.0087 13.8639 12.251 13.6216C12.4933 13.3793 12.6294 13.0506 12.6294 12.7079V8.18533",
    stroke: "#404040",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6608 1.40142C11.9178 1.1444 12.2664 1 12.6299 1C12.9934 1 13.342 1.1444 13.599 1.40142C13.8561 1.65845 14.0005 2.00705 14.0005 2.37054C14.0005 2.73403 13.8561 3.08264 13.599 3.33966L7.46127 9.47743L4.87695 10.1235L5.52303 7.53919L11.6608 1.40142Z",
    stroke: "#404040",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTagDelete);
export default __webpack_public_path__ + "static/media/add-tag-delete.e7f48c3a294f28bed2dad62def6f10cf.svg";
export { ForwardRef as ReactComponent };